




























































































































































































































































































































































































// https://material.io/resources/icons/?style=baseline
import Vue from 'vue'
import axios from 'axios'
import { Category, MaxEvent, Week, Day, MaxSubmitEvent, CategorySelection, Util } from '@/types'
import { Dictionary } from 'vue-router/types/router'
import Datepicker from 'vuejs-datepicker'

const psServer = 'https://client-cal.dns9.co/'
// const psServer = 'http://localhost:8088/'

export default Vue.extend({
  name: 'MaxCalendar',
  created: function () {
    this.SetCategoryList()
    this.SetWeek(this.SelectedDate)
    this.SetWeekList(this.SelectedDate)
  },
  mounted: function () {
    this.OnResize()
    window.addEventListener('resize', this.OnResize)
  },
  components: {
    Datepicker
  },
  props: {
    msg: String
  },
  data () {
    return {
      WeekDayNameList: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
      ] as Array<string>,
      IsMonthView: false as boolean,
      IsListView: true as boolean,
      SearchTerm: '' as string,
      SelectedCategoryName: 'ALL' as string,
      SelectedDate: new Date() as Date,
      WeekListIndex: {} as Dictionary<Array<Week>>,
      WeekIndex: {},
      EventListIndex: {} as Dictionary<Array<MaxEvent>>,
      WeekListStartDate: new Date() as Date,
      WeekStartDate: new Date() as Date,
      SelectedEvent: {} as MaxEvent,
      SelectedSearchTerm: '' as string,
      CategoryList: [] as Array<Category>,
      MonthStartDate: {} as Date,
      IsSubmitEventView: false as boolean,
      StartDate: '' as string,
      StartTime: '' as string,
      IsStartTimePickView: false as boolean,
      EndTime: '' as string,
      IsEndTimePickView: false as boolean,
      EventToSubmit: {} as MaxSubmitEvent,
      EventToSubmitStartTime: '' as string,
      EventToSubmitEndTime: '' as string,
      IsEventFormValid: true as boolean,
      SubmitEventText: 'Submit Event' as string,
      IsShowSubmitDialog: false as boolean,
      IsShowSubmitDialogError: false as boolean,
      DefaultCategoryName: 'Spotlight' as string,
      StartTimePick: '' as string,
      EndTimePick: '' as string,
      IsWidthLarge: false as boolean,
      IsWidthMedium: false as boolean,
      ComponentWidth: 0 as number,
      IsFullWidth: false as boolean,
      StyleEventSubmitCategory: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        height: '100px',
        width: '100%'

      }
    }
  },
  methods: {
    OnClickToday (): void {
      this.SetSelectedDate(new Date())
      this.IsSubmitEventView = false
    },
    OnSelectDateWithDatePicker (ldDate: Date): void {
      this.SetSelectedDate(ldDate)
      this.IsSubmitEventView = false
    },
    OnClickWeek (): void {
      this.IsMonthView = false
      this.IsSubmitEventView = false
    },
    OnClickMonth (): void {
      this.IsMonthView = true
      this.IsSubmitEventView = false
    },
    OnSearch (): void {
      if (typeof (this.EventListIndex[this.SearchTerm]) !== 'undefined') {
        this.SelectedSearchTerm = this.SearchTerm
      } else {
        axios.post(psServer + 'MaxCalendarApi/geteventbysearch', { Term: this.SearchTerm }).then(response => {
          const laEventList: Array<MaxEvent> = []
          for (let lnE = 0; lnE < response.data.length; lnE++) {
            const loEvent: MaxEvent = response.data[lnE] as MaxEvent
            const ldStartDate: Date = new Date(loEvent.Start)
            loEvent.Date = (ldStartDate.getMonth() + 1) + '/' + ldStartDate.getDate() + '/' + (ldStartDate.getFullYear() - 2000)
            laEventList.push(loEvent)
          }

          this.EventListIndex[this.SearchTerm] = laEventList
          this.SelectedCategoryName = 'ALL'
          this.SelectedSearchTerm = this.SearchTerm
        })
      }
    },
    OnClickStartTimePickOK () {
      const lsAMPM = Util.ConvertToAMPM(this.StartTimePick)
      this.EventToSubmitStartTime = lsAMPM
      this.IsStartTimePickView = false
    },
    OnClickEndTimePickOK () {
      const lsAMPM = Util.ConvertToAMPM(this.EndTimePick)
      this.EventToSubmitEndTime = lsAMPM
      this.IsEndTimePickView = false
    },
    OnClickSubmitEvent () {
      this.IsSubmitEventView = true
    },
    OnClickCloseSubmitEvent () {
      this.IsSubmitEventView = false
    },
    OnClickSubmitEventProcess () {
      if ((this.$refs.EventForm as Vue & { validate: () => boolean }).validate()) {
        this.EventToSubmit.StartTime = Util.ConvertTo24Hour(this.EventToSubmitStartTime)
        this.EventToSubmit.EndTime = Util.ConvertTo24Hour(this.EventToSubmitEndTime)
        // console.log(JSON.stringify(this.EventToSubmit))
        this.EventToSubmit.CategoryNameList = []
        this.EventToSubmit.CategorySelectionList.forEach(loCategory => {
          if (loCategory.Selected) {
            this.EventToSubmit.CategoryNameList.push(loCategory.Name)
          }
        })

        axios.post(psServer + 'MaxCalendarApi/submitevent', this.EventToSubmit).then(response => {
          if (response.data === 'success') {
            this.IsShowSubmitDialog = true
          } else {
            this.IsShowSubmitDialogError = true
          }
        })
      }
    },
    OnClickSubmitEventSimilar () {
      this.IsShowSubmitDialog = false
    },
    OnClickSubmitEventNew () {
      (this.$refs.EventForm as Vue & { reset: () => void }).reset()
      this.IsShowSubmitDialog = false
    },
    OnClickSubmitEventDone () {
      (this.$refs.EventForm as Vue & { reset: () => void }).reset()
      this.IsShowSubmitDialog = false
      this.IsSubmitEventView = false
    },
    SetCategoryList (): void {
      axios
        .post(psServer + 'MaxCalendarApi/getcategorylist')
        .then((response) => {
          const laList: Array<Category> = response.data as Array<Category>
          const laSelectionList: Array<CategorySelection> = new Array<CategorySelection>()
          for (let lnL = 0; lnL < laList.length; lnL++) {
            if (laList[lnL].Id !== '221dfe4a-f2c0-4bff-889e-6f4f55b29f3b' &&
            laList[lnL].Id !== 'fb2feaab-fc18-4218-b069-0c0dcada9a46') {
              laSelectionList.push({ Name: laList[lnL].Name, Id: laList[lnL].Id, Selected: '' })
            } else {
              this.DefaultCategoryName = laList[lnL].Name
            }
          }

          this.EventToSubmit.CategorySelectionList = laSelectionList
          laList.unshift({ Name: 'ALL', Id: 'ALL' })
          this.CategoryList = laList
          this.SelectedCategoryName = this.DefaultCategoryName
          this.SetStyleEventSubmitCategory(this.ComponentWidth)
        })
    },
    OnResize () {
      if (this.IsFullWidth) {
        this.ComponentWidth = document.documentElement.clientWidth
      } else {
        const loDiv: HTMLElement = document.getElementById('udMaxCalendar') as HTMLElement
        if (document.documentElement.clientWidth === loDiv.clientWidth) {
          this.IsFullWidth = true
          this.ComponentWidth = document.documentElement.clientWidth
        } else {
          const loAppDiv: HTMLElement = document.getElementById('udMaxCalendarApp') as HTMLElement
          if (loAppDiv != null) {
            const loParentDiv: HTMLElement = loAppDiv.parentElement as HTMLElement
            if (loParentDiv != null && loParentDiv.style.width != null && loParentDiv.style.width.length > 0) {
              this.ComponentWidth = parseInt(loParentDiv.style.width, 10)
            } else if (loParentDiv != null) {
              const lsWidth = getComputedStyle(loParentDiv).getPropertyValue('width')
              if (lsWidth != null && lsWidth.length > 0) {
                this.ComponentWidth = parseInt(lsWidth, 10)
              }
            }
          } else if (window.innerWidth > 735) {
            this.ComponentWidth = 735
          } else {
            this.ComponentWidth = 320
          }
        }
      }
    },
    SetStyleEventSubmitCategory (lnWidth: number) {
      let lnColCount = 5
      if (lnWidth < 550) {
        lnColCount = 1
      } else if (lnWidth < 700) {
        lnColCount = 2
      } else if (lnWidth < 850) {
        lnColCount = 3
      } else if (lnWidth < 1000) {
        lnColCount = 4
      }

      const lnPerCol: number = this.EventToSubmit.CategorySelectionList.length / lnColCount
      const lnHeight: number = Math.ceil(lnPerCol) * 50
      this.StyleEventSubmitCategory.height = lnHeight + 'px'
    },
    SetSelectedDate (ldDate: Date) {
      this.SelectedSearchTerm = ''
      if (!this.IsDateSame(this.SelectedDate, ldDate) && typeof (ldDate) === typeof (new Date())) {
        this.SelectedDate = ldDate
      }

      this.SetWeek(ldDate)
      this.SetWeekList(ldDate)
      this.IsListView = true
      // this.SelectedCategoryName = this.DefaultCategoryName
    },
    IsDateSame (ldDate1: Date, ldDate2: Date): boolean {
      if (typeof (ldDate1) !== typeof (new Date()) || typeof (ldDate2) !== typeof (new Date())) {
        return false
      }

      return (this.GetDateText(ldDate1) === this.GetDateText(ldDate2))
    },
    GetDateText (ldDate: Date): string {
      return ldDate.getFullYear() + '-' + ldDate.getMonth() + '-' + ldDate.getDate()
    },
    SetWeek (ldDate: Date) {
      const ldWeekStartDate: Date = new Date(ldDate.valueOf())
      ldWeekStartDate.setDate(ldWeekStartDate.getDate() - ldWeekStartDate.getDay())
      if (this.WeekStartDate !== ldWeekStartDate) {
        this.WeekStartDate = new Date(ldWeekStartDate.valueOf())
      }
    },
    SetWeekList (ldDate: Date) {
      const ldMonthStartDate = new Date(ldDate.valueOf())
      ldMonthStartDate.setDate(1) /// / Set to the first of the month
      this.MonthStartDate = ldMonthStartDate
      this.UpdateWeekListIndex()
    },
    IsSelectedDate (ldDate: Date) {
      return this.IsDateSame(ldDate, this.SelectedDate)
    },
    IsCurrentMonth (ldDate: Date) {
      return (this.MonthStartDate.getMonth() === ldDate.getMonth())
    },
    OnClickWeekDay (event: Event) {
      let loTarget: HTMLElement = event.target as HTMLElement

      while (typeof (loTarget.dataset.date) === 'undefined') {
        loTarget = loTarget.parentNode as HTMLElement
      }

      const lsDate: string = loTarget.dataset.date as string
      this.SetSelectedDate(new Date(lsDate))
    },
    OnClickMonthDay (event: Event) {
      const loTarget: HTMLElement = event.target as HTMLElement
      let loDate: HTMLElement = event.target as HTMLElement
      while (typeof (loDate.dataset.date) === 'undefined') {
        loDate = loDate.parentNode as HTMLElement
      }

      const ldDate: Date = new Date(loDate.dataset.date as string)
      this.SetSelectedDate(ldDate)
      if (loTarget.nodeName === 'A') {
        const lsEventId: string = loTarget.dataset.eventid as string
        if (lsEventId != null) {
          const loEvent: MaxEvent = this.GetEvent(lsEventId)
          this.ShowEvent(loEvent)
        }
      }
    },
    GetEvent (lsId: string): MaxEvent {
      const laKey: Array<string> = Object.keys(this.EventListIndex)
      for (let lnK = 0; lnK < laKey.length; lnK++) {
        const lsKey: string = laKey[lnK]
        for (let lnE = 0; lnE < this.EventListIndex[lsKey].length; lnE++) {
          if (this.EventListIndex[lsKey][lnE].Id === lsId) {
            return this.EventListIndex[lsKey][lnE]
          }
        }
      }

      return { Title: 'not found', Start: new Date(), CategoryNameList: [], Id: '', Description: '', Location: '', Price: '', End: new Date(), Date: '', StartTime: '', EndTime: '', Phone: '', Website: '', Email: '' }
    },
    ShowEvent (loEvent: MaxEvent): void {
      this.IsListView = false
      this.SelectedEvent = loEvent
    },
    OnClickPreviousMonth (): void {
      const ldDate = new Date(this.MonthStartDate.valueOf())
      ldDate.setDate(1)
      ldDate.setMonth(ldDate.getMonth() - 1)
      this.MonthStartDate = ldDate
    },
    OnClickPreviousWeek (): void {
      const ldDate = new Date(this.WeekStartDate.valueOf())
      ldDate.setDate(ldDate.getDate() - 7)
      this.SetWeek(ldDate)
    },
    OnClickNextMonth (): void {
      const ldDate = new Date(this.MonthStartDate.valueOf())
      ldDate.setDate(1)
      ldDate.setMonth(ldDate.getMonth() + 1)
      this.MonthStartDate = ldDate
    },
    OnClickNextWeek (): void {
      const ldDate = new Date(this.WeekStartDate.valueOf())
      ldDate.setDate(ldDate.getDate() + 7)
      this.SetWeek(ldDate)
    },
    OnClickEvent (event: Event) {
      let loRow: HTMLElement = event.target as HTMLElement
      while (loRow.nodeName !== 'TR') {
        loRow = loRow.parentNode as HTMLElement
      }

      const loEvent: MaxEvent = this.GetEvent(loRow.dataset.eventid as string)
      this.ShowEvent(loEvent)
    },
    OnClickCloseDescription () {
      this.IsListView = true
    },
    UpdateWeekListIndex (): void {
      const ldMonthStartDate: Date = new Date(this.MonthStartDate.valueOf())
      const ldWeekListStartDate = new Date(ldMonthStartDate.valueOf())
      ldWeekListStartDate.setDate(1 - ldWeekListStartDate.getDay()) /// / Set to the first day of the week that has the first day of the month
      const lsKey: string = this.GetDateText(ldWeekListStartDate)
      const ldEndDate: Date = new Date(ldWeekListStartDate.valueOf())
      ldEndDate.setDate(ldEndDate.getDate() + 40) /// / Get 40 days worth of events just to make sure
      const lsEndDate: string = ldEndDate.getFullYear() + '-' + (ldEndDate.getMonth() + 1) + '-' + ldEndDate.getDate()
      const lsStartDate: string = ldWeekListStartDate.getFullYear() + '-' + (ldWeekListStartDate.getMonth() + 1) + '-' + ldWeekListStartDate.getDate()
      if (this.WeekListIndex[lsKey] == null) {
        axios.post(psServer + 'MaxCalendarApi/geteventbydaterange', { StartDate: lsStartDate, EndDate: lsEndDate }).then(response => {
          let ldDateCurrent: Date = new Date(ldWeekListStartDate.valueOf())
          while (ldDateCurrent < ldEndDate) {
            const laEventList: Array<MaxEvent> = []
            for (let lnE = 0; lnE < response.data.length; lnE++) {
              const loEvent: MaxEvent = response.data[lnE] as MaxEvent
              const ldStartDate: Date = new Date(loEvent.Start)
              loEvent.Date = (ldStartDate.getMonth() + 1) + '/' + ldStartDate.getDate() + '/' + (ldStartDate.getFullYear() - 2000)
              if (this.IsDateSame(ldDateCurrent, ldStartDate)) {
                laEventList.push(loEvent)
              }
            }

            Vue.set(this.EventListIndex, this.GetDateText(ldDateCurrent), laEventList)
            ldDateCurrent.setDate(ldDateCurrent.getDate() + 1)
            ldDateCurrent = new Date(ldDateCurrent.valueOf())
          }

          let lnDayCurrent = 0
          const loWeekList: Array<Week> = []
          for (let lnW = 1; lnW < 7; lnW++) {
            const loWeek: Week = { WeekNum: lnW, DayList: [] }
            const loDayList: Array<Day> = []
            for (let lnD = 0; lnD < 7; lnD++) {
              const ldDay: Date = new Date(ldWeekListStartDate.valueOf())
              ldDay.setDate(ldDay.getDate() + lnDayCurrent)

              const loDay: Day = { Day: ldDay.getDate(), Date: ldDay, DayOfWeek: ldDay.getDay(), EventList: this.EventListIndex[this.GetDateText(ldDay)] }
              loDayList.push(loDay)
              const ldNextDay: Date = new Date(ldDay.valueOf())
              ldNextDay.setDate(ldNextDay.getDate() + 1)
              if (ldNextDay.getFullYear() * 12 + ldNextDay.getMonth() > ldMonthStartDate.getFullYear() * 12 + ldMonthStartDate.getMonth()) {
                lnW = 7
              }

              lnDayCurrent++
            }

            loWeek.DayList = loDayList
            loWeekList.push(loWeek)
          }

          Vue.set(this.WeekListIndex, lsKey, loWeekList)
        })
      }
    }
  },
  computed: {
    EventList: function (): Array<MaxEvent> {
      const laR: Array<MaxEvent> = []
      let laEventList: Array<MaxEvent> = this.EventListIndex[this.SelectedSearchTerm]
      if (typeof (laEventList) === 'undefined') {
        laEventList = this.EventListIndex[this.GetDateText(this.SelectedDate)]
      }

      if (typeof (laEventList) !== 'undefined') {
        for (let lnE = 0; lnE < laEventList.length; lnE++) {
          const loEvent: MaxEvent = laEventList[lnE]
          if (this.SelectedCategoryName === 'ALL' || loEvent.CategoryNameList.includes(this.SelectedCategoryName)) {
            laR.push(loEvent)
          }
        }
      }

      return laR
    },
    IsWeekView: function (): boolean {
      return !this.IsMonthView
    },
    IsDetailView: function (): boolean {
      return !this.IsListView
    },
    IsCalendarView: function (): boolean {
      return !this.IsSubmitEventView
    },
    Week: function (): Week {
      let lnDayCurrent = 0
      const loR: Week = { WeekNum: 0, DayList: [] }
      const loDayList: Array<Day> = []
      for (let lnD = 0; lnD < 7; lnD++) {
        const ldDay = new Date(this.WeekStartDate.valueOf())
        ldDay.setDate(this.WeekStartDate.getDate() + lnDayCurrent)
        const loDay: Day = { Day: ldDay.getDate(), Date: ldDay, DayOfWeek: ldDay.getDay(), EventList: [] }
        loDayList.push(loDay)
        lnDayCurrent++
      }

      loR.DayList = loDayList
      return loR
    },
    WeekList: function (): Array<Week> {
      let laR: Array<Week> = []
      const ldMonthStartDate = new Date(this.MonthStartDate.valueOf())
      const ldWeekListStartDate = new Date(ldMonthStartDate.valueOf())
      ldWeekListStartDate.setDate(1 - ldWeekListStartDate.getDay()) /// / Set to the first day of the week that has the first day of the month
      const lsKey = this.GetDateText(ldWeekListStartDate)
      if (typeof (this.WeekListIndex[lsKey]) !== 'undefined') {
        laR = this.WeekListIndex[lsKey]
      } else {
        this.UpdateWeekListIndex()
      }

      return laR
    },
    IsSearchView: function (): boolean {
      if (this.SelectedSearchTerm.length > 0) {
        return true
      }

      return false
    },
    MonthName: function (): string {
      if (this.IsMonthView) {
        return this.MonthStartDate.toLocaleString('default', { month: 'long' }).toUpperCase()
      }

      return this.WeekStartDate.toLocaleString('default', { month: 'long' }).toUpperCase()
    },
    RuleRequired: function (): Array<Function> {
      const laR: Array<Function> = [
        (value: string) => !!value || 'Required'
      ]

      return laR
    }
  },
  watch: {
    IsEventFormValid: function () {
      if (this.IsEventFormValid) {
        this.SubmitEventText = 'Submit Event'
      } else {
        this.SubmitEventText = 'There is a validation error'
      }
    },
    EventToSubmitStartTime: function () {
      const ls24Hr = Util.ConvertTo24Hour(this.EventToSubmitStartTime)
      if (this.EventToSubmitStartTime !== ls24Hr) {
        this.StartTimePick = ls24Hr
      }
    },
    EventToSubmitEndTime: function () {
      const ls24Hr = Util.ConvertTo24Hour(this.EventToSubmitEndTime)
      if (this.EventToSubmitEndTime !== ls24Hr) {
        this.EndTimePick = ls24Hr
      }
    },
    ComponentWidth: function () {
      const loDiv: HTMLElement = document.getElementById('udMaxCalendar') as HTMLElement
      loDiv.style.width = this.ComponentWidth + 'px'

      if (this.ComponentWidth > 1024) {
        this.IsWidthLarge = true
        this.IsWidthMedium = true
      } else {
        this.IsWidthLarge = false
        if (this.ComponentWidth >= 730) {
          this.IsWidthMedium = true
        } else {
          this.IsWidthMedium = false
        }
      }
    }
  }
})
